(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgc-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rail = document.querySelector('[data-rgc-rail]');
    if (rail && rail.dataset.ready !== 'true') {
      rail.dataset.ready = 'true';
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let timer;
        const stop = () => window.clearInterval(timer);
        const start = () => { stop(); timer = window.setInterval(() => {
          const card = rail.querySelector('.rgc-card'); if (!card || rail.scrollWidth <= rail.clientWidth) return;
          const gap = parseFloat(window.getComputedStyle(rail).gap) || 0; const step = card.getBoundingClientRect().width + gap;
          const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - step / 2;
          rail.scrollTo({ left: atEnd ? 0 : rail.scrollLeft + step, behavior: 'smooth' });
        }, 3600); };
        ['mouseenter','focusin','pointerdown'].forEach(event => rail.addEventListener(event, stop));
        ['mouseleave','focusout','pointerup'].forEach(event => rail.addEventListener(event, start)); start();
      }
    }
    const countdown = document.querySelector('[data-rgc-countdown]'); if (!countdown || countdown.dataset.ready === 'true') return; countdown.dataset.ready = 'true';
    const end = new Date(countdown.dataset.end).getTime(); const fields = {days:countdown.querySelector('[data-rgc-days]'),hours:countdown.querySelector('[data-rgc-hours]'),minutes:countdown.querySelector('[data-rgc-minutes]'),seconds:countdown.querySelector('[data-rgc-seconds]')};
    const pad = value => String(value).padStart(2,'0'); const update = () => { const remaining = Math.max(0,end-Date.now()); const total = Math.floor(remaining/1000); fields.days.textContent=String(Math.floor(total/86400)); fields.hours.textContent=pad(Math.floor((total%86400)/3600)); fields.minutes.textContent=pad(Math.floor((total%3600)/60)); fields.seconds.textContent=pad(total%60); if(remaining===0) countdown.setAttribute('aria-label','The Halloween edit is here'); };
    update(); window.setInterval(update,1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
